﻿// NG 2
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


// APP
import { AppConfig } from '../app.config';
import { AuthenticationService } from './authentication.service';
import { ProgressService } from './progress.service';
import { BaseService } from './base.service';
import { SaveEntityContact, AppModeUpdateModel, AppMode } from './../viewmodel';
import { SaveSiteEntityContact } from './../viewmodel';
import { DeleteEntity } from './../viewmodel';

@Injectable()
export class EntityService extends BaseService {    
    _baseUrl: string = AppConfig.config.defaultServicePath + 'MIHEntity/';
    _baseNotificationServiceUrl: string = AppConfig.config.defaultServicePath + 'Notification/'; 
    _baseNotificationUrl: string = AppConfig.config.notificationUrl;

    constructor(private http: Http
        , private authenticationService: AuthenticationService
        , private progressService: ProgressService) {
        super();
    }


    saveEntity(entity) {
        this.progressService.add();
      
        return this.http.post(this._baseUrl + 'SaveEntity', entity, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getEntities(projectId) {
       // this.progressService.add();        
        return this.http.get(this._baseUrl + 'GetEntities?projectId=' + projectId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            //.finally(() => this.progressService.remove())
           
    }

    getActiveEntitiesAndCurrentPendingEntity(projectId, entityId, partyId, partyStagingId, partyRoleSeqNo) {
        this.progressService.add(); 

        return this.http.get(this._baseUrl + 'GetActiveEntitiesAndCurrentPendingEntity?projectId=' + projectId + '&entityId=' + entityId + '&partyId=' + partyId + '&partyStagingId=' + partyStagingId + '&partyRoleSeqNo=' + partyRoleSeqNo, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getContacts(entityAdded) {
         this.progressService.add();            
        //return this.http.get(this._baseUrl + 'GetEntityContacts?entityAdded=' + entityAdded, this.addHeader())
        return this.http.post(this._baseUrl + 'GetEntityContacts', entityAdded, this.addHeader())
            .map((resp: Response) => resp.json())
             .catch(this.errorHandler)
            .finally(() => this.progressService.remove())        
    }

    getSiteEntityContacts(entityAdded) {

        this.progressService.add(); 
        return this.http.post(this._baseUrl + 'GetSiteEntityContacts', entityAdded, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getEntityById(entityId) {
        this.progressService.add();               
        return this.http.get(this._baseUrl + 'GetEntitiyByEntityId?entityId=' + entityId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetMIHProjectDevTeamContactByMIHProjectDevTeamContactID(MIHProjectDevTeamContactID) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetMIHProjectDevTeamContactByMIHProjectDevTeamContactID?MIHProjectDevTeamContactID=' + MIHProjectDevTeamContactID, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    deleteDevTeamEntity(entityId, deleteCompanyName, projectId) {
        this.progressService.add();
        var body: DeleteEntity = new DeleteEntity();
        body.projectId = projectId; 
        body.entityId = entityId;
        body.companyName = deleteCompanyName; 
                 
        return this.http.post(this._baseUrl + 'DeleteDevTeamEntity', body, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    deleteDevTeamContact(devTeamContactId) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'DeleteDevTeamContact', devTeamContactId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }
    
    deleteSiteTeamEntity(siteTeamEntityId) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'DeleteSiteTeamEntity', siteTeamEntityId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    deleteSiteTeamContact(siteTeamContactId) {

        this.progressService.add();
        return this.http.post(this._baseUrl + 'DeleteSiteTeamContact', siteTeamContactId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getUserProjects() {       
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetEntityByUserId', this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getProjectDetailById(projectId) {        
        //this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectDetailById?projectId=' + projectId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            //.finally(() => this.progressService.remove())
    }

    getMaintenanceNotification() {
        this.progressService.add();
        return this.http.get(this._baseNotificationServiceUrl + 'MaintenanceNotification', this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getNotification() {
        this.progressService.add();
        return this.http.get(this._baseNotificationUrl)
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    addApplicationName(addAppName) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'AddApplication', addAppName, this.addHeader())
        //return this.http.post(this._baseUrl + 'AddApplication', JSON.parse(JSON.stringify({ addAppName: addAppName } || null)), this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())

    }

    submitApplication(projectId) {
        this.progressService.add();
    
        return this.http.post(this._baseUrl + 'SubmitApplication', projectId, this.addHeader())
       // return this.http.post(this._baseUrl + 'SubmitApplication', addAppName, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

      searchAddress(entity) {

        this.progressService.add();
        //return this.http.post(this._baseUrl + 'GetVerifiedPartyByLegalNameTaxIdDetails', entity, this.addHeader())
        return this.http.post(this._baseUrl + 'SearchAddress', entity, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

      saveEntityContact(contact) {
          this.progressService.add();

          return this.http.post(this._baseUrl + 'saveEntityContact', contact, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      saveNewEntityContact(contact, entityParam) {
          this.progressService.add();          
          var body: SaveEntityContact = new SaveEntityContact();
          body.contact = contact;
          body.entityParamForContact = entityParam;

          return this.http.post(this._baseUrl + 'saveNewEntityContact', body, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      saveSiteEntity(entity) {
          this.progressService.add();
          return this.http.post(this._baseUrl + 'SaveSiteEntity', entity, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      saveSiteEntityContact(contact) {
          this.progressService.add();
          return this.http.post(this._baseUrl + 'saveSiteEntityContact', contact, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      SaveNewSiteEntityContact(contact,siteEntityParam) {
          this.progressService.add();
          var body: SaveSiteEntityContact = new SaveSiteEntityContact();
          body.contact = contact;
          body.siteEntityParam = siteEntityParam;

          return this.http.post(this._baseUrl + 'SaveNewSiteEntityContact', body, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }


      getSiteEntitiyBySiteEntityId(siteentityId) {
          this.progressService.add();
         
          return this.http.get(this._baseUrl + 'GetSiteEntitiyBySiteEntityId?sityEntityId=' + siteentityId, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

    //get siteEntityContact
      GetMIHProjectBldgDevTeamContactByMIHProjectBldgDevTeamContactID(MIHProjectBldgDevTeamContactID) {
         
          this.progressService.add();
          return this.http.get(this._baseUrl + 'GetMIHProjectBldgDevTeamContactByMIHProjectBldgDevTeamContactID?MIHProjectBldgDevTeamContactID=' + MIHProjectBldgDevTeamContactID, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      getSiteContactBycomContactId(commContactId) {
          this.progressService.add();
          return this.http.get(this._baseUrl + 'GetSiteContactByCommContactId?commContactId=' + commContactId, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      //GetDevTeamEntitiesForSite(long projectId, long siteProjBuildingId)
      getDevTeamEntitiesForSite(projectId, siteProjBuildingId) {         
          this.progressService.add();
          return this.http.get(this._baseUrl + 'GetDevTeamEntitiesForSite?projectId=' + projectId + '&siteProjBuildingId=' + siteProjBuildingId, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      //AssociateDevTeamEntitiestoSite: (long projectId, long siteProjBuildingId, long bldgId, long[] ProjDevTeamIds)
      AssociateDevTeamEntitiestoSite(ProjDevTeamIds) {
          this.progressService.add();
          return this.http.post(this._baseUrl + 'AssociateDevTeamEntitiestoSite', ProjDevTeamIds, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())

      }


      DeleteApplication(projectId) {
          this.progressService.add();
          return this.http.post(this._baseUrl + 'DeleteApplication', projectId, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      DeleteApplicationAndCleanup(projectId) {
          this.progressService.add();
          return this.http.post(this._baseUrl + 'DeleteApplicationAndCleanup', projectId, this.addHeader())
              .map((resp: Response) => resp.json())
              .catch(this.errorHandler)
              .finally(() => this.progressService.remove())
      }

      changeToEditMode(applicationId: number) {        
        this.progressService.add();
        let body: AppModeUpdateModel = new AppModeUpdateModel();
        body.ProjectId = applicationId;
        body.Mode = AppMode.Edit;
        return this.http.post(this._baseUrl + 'UpdateApplicationMode', body, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

}
